module.exports = __webpack_public_path__ + "static/media/template-coupons.00b6a9fe.csv";